import { render } from "./event_sponsor.html?vue&type=template&id=752f0698&external"
import script from "./event_sponsor.js?vue&type=script&lang=js&external"
export * from "./event_sponsor.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__